import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { firstValueFrom, timeout } from 'rxjs';
import { AuthService } from '@app/services/auth/auth';
import { GtmService } from '@app/services/gtm/gtm';
import { userActions } from '@app/store/user/user.actions';

const TIMEOUT_MS = 15_000;

export async function userDetailsInitializer(): Promise<void> {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return;
  }

  const authService = inject(AuthService);
  const gtmService = inject(GtmService);

  if (!authService.isAuthenticated()) {
    return;
  }

  const store = inject(Store);
  const actions$ = inject(Actions);

  store.dispatch(userActions.userDetailsGroup.loadUserDetails());

  const result = await firstValueFrom(
    actions$.pipe(
      ofType(
        userActions.userDetailsGroup.loadUserDetailsSuccess,
        userActions.userDetailsGroup.loadUserDetailsFailure,
      ),
      timeout(TIMEOUT_MS),
    ),
  );

  /* Pushed only once the details arrive: `user_data` (email, phone, name, postcode) is not in the
     session cookie, and Meta's match quality depends on it. A failed load pushes nothing. */
  if (result.type === userActions.userDetailsGroup.loadUserDetailsSuccess.type) {
    await gtmService.pushUserId(result.response.id.toString(), result.response);
  }
}
